import { HeaderColumn } from '@tableau/widgets-datagrid';
import * as React from 'react';

export function defaultHeaderFormatter(): React.Factory<HeaderColumn.HeaderFormatterProps> {
  return React.createFactory((props) => {
    return (
      <div title={props.col.headerText} style={{ padding: '0 12px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {props.col.headerText}
      </div>
    );
  });
}
